/**
*  料金シミュレーター
*
*  短期入所 & 短期入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_short = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  income : [ 1730, 300, 600, 1000, 1300 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 530, 0, 370, 370, 370 ],
    two  : [ 1630, 1100, 1470, 1470, 1470 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 3580, 2140, 2140, 2960, 2960 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1727, 3015, 4303 ],
        two  : [ 1727, 3015, 4303 ]
      },
      single : [ 1641, 2843, 4044 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1809, 3178, 4547 ],
          two  : [ 1809, 3178, 4547 ]
        },
      single : [ 1719, 2998, 4278 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1876, 3312, 4748 ],
          two  : [ 1876, 3312, 4748 ]
        },
      single : [ 1786, 3133, 4479 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1937, 3434, 4931 ],
          two  : [ 1937, 3434, 4931 ]
        },
      single : [ 1848, 3257, 4665 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1998, 3557, 5116 ],
          two  : [ 1998, 3557, 5116 ]
        },
      single : [ 1908, 3376, 4844 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1496, 2552, 3609 ],
          two  : [ 1496, 2552, 3609 ]
        },
      single : [ 1454, 2469, 3484 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1666, 2892, 4118 ],
          two  : [ 1666, 2892, 4118 ]
        },
      single : [ 1607, 2774, 3942 ]
    }
  ]
}




/**
*  function
*  動作
*/

// 短期入所
$( calcBtn.shortStay ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStay ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStay, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_short.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_short.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_short.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_short.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStay ).html( numberWithComma.format( result ) );
    $( resultElm.shortStayDays ).html( selectVal.days );
  } // end of 計算処理開始
return;
});



// 短期入所（認知棟）
$( calcBtn.shortStaySub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStaySub ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStaySub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_short.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_short.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_short.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_short.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStaySub ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始

return;

});
